import { render, staticRenderFns } from "./bioDetection.vue?vue&type=template&id=5cdd590d"
import script from "./bioDetection.vue?vue&type=script&lang=js"
export * from "./bioDetection.vue?vue&type=script&lang=js"
import style0 from "./bioDetection.vue?vue&type=style&index=0&id=5cdd590d&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports